import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import FormError from "../../../components/forms/FormError";

class StopServiceForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Specify a reason for stopping service.</p>
          <FormFieldsTable>          
            <Field
              label="Reason"
              name="reason"
              component={TextInputField}
              serverError={this.props.errors.reason}
              />   
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "StopServiceForm"
})(StopServiceForm);

export default ReduxForm;